import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useCart } from "@/common/Contexts/CartContext";
import OilCancelModal from "../OilCancelModal/OilCancelModal";
import useHelpers from "@hooks/useHelpers";
import useTranslation from "@/i18n/useTranslation";
import SAR from "@/componentsShared/SAR/SAR";
import { Icon } from "@syarahtech/ui";
var CartArrowIcon = function CartArrowIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6h24l-3 13H9m18 4H10L5 2H2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "27",
    r: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "27",
    r: "2"
  })));
};
var OilStickyBar = function OilStickyBar() {
  var _useCart = useCart(),
    totalItems = _useCart.totalItems,
    totalCurrentPrice = _useCart.totalCurrentPrice;
  var _useState = useState(false),
    showModal = _useState[0],
    setShowModal = _useState[1];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useTranslation = useTranslation(["web_oils"]),
    tShort = _useTranslation.tShort;
  if (totalItems === 0) return null;
  var formattedPrice = totalCurrentPrice.toFixed(1);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fixed bottom-0 start-0 end-0 z-[20000] bg-white border-t border-[#E9EEF5] shadow-[0_-4px_16px_rgba(0,0,0,0.08)]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-6 py-3 md:py-0 md:px-6 md:max-w-[1200px] md:mx-auto flex items-center justify-between gap-3 h-28 md:h-24"
  }, /*#__PURE__*/React.createElement("button", {
    className: "bg-transparent border-0 text-primary-new text-sm font-bold cursor-pointer px-1 py-2 whitespace-nowrap",
    onClick: function onClick() {
      return setShowModal(true);
    }
  }, tShort("sticky_bar/cancel", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("a", {
    href: createUrl('/site/cart'),
    className: "flex justify-between items-center gap-3 w-auto min-w-[258px] max-w-full md:w-[310px] md:min-w-0 bg-primary-new text-white hover:text-white no-underline px-5 py-2.5 md:px-8 md:py-3 rounded-[6px] text-sm md:text-[15px] font-bold whitespace-nowrap duration-150 flex-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative flex  items-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--shopping-cart-outline-rounded",
    className: "text-white",
    width: 6,
    height: 6
  }), totalItems > 0 && /*#__PURE__*/React.createElement("span", {
    className: "absolute -top-2 -start-2 min-w-[18px] h-[18px] bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-[3px]"
  }, totalItems)), /*#__PURE__*/React.createElement("span", {
    className: "block text-base"
  }, tShort("sticky_bar/go_to_cart", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("strong", {
    className: "opacity-90 font-extrabold block text-base"
  }, formattedPrice, " ", /*#__PURE__*/React.createElement(SAR, null))))), /*#__PURE__*/React.createElement(OilCancelModal, {
    open: showModal,
    onClose: function onClose() {
      return setShowModal(false);
    }
  }));
};
export default OilStickyBar;